import { Stack, Typography } from '@mui/material'
import dayjs from 'dayjs'
import { observer } from 'mobx-react-lite'
import { EmptyIndicator } from 'modules/ui/src/theme/components/form/empty-indicator'

interface Props {
  date?: string | Date | null
}
export const VesselKPIDate = observer(({ date }: Props) => {
  if (!date) return <Typography variant='h3'>{EmptyIndicator}</Typography>

  return (
    <Stack>
      <Typography variant='body2'>{dayjs(date).format('L')}</Typography>
      <Typography variant='subtitle2'>
        {new Date(date).toLocaleTimeString([], {
          timeStyle: 'short',
          hour12: false,
        }) ?? EmptyIndicator}
      </Typography>
    </Stack>
  )
})
